const BASE_PATH = '/onboarding/business';

export const BUSINESS_ONBOARDING_ROUTES = {
  SIGN_UP: BASE_PATH + '/signup',
  YOUR_NAME: BASE_PATH + '/your-name',
  PRODUCTS: BASE_PATH + '/products',
  CHECKOUT: BASE_PATH + '/checkout',
  START_TRIAL: BASE_PATH + '/start-trial',
  START_SUBSCRIPTION: BASE_PATH + '/start-subscription',
  CHOOSE_SEATS: BASE_PATH + '/0/choose-seats',
  SETUP_WORKSPACE: BASE_PATH + '/0/setup-workspace', // This is the new workspace onboarding flow
};

/** Minimum card quantity for business subscription */
export const FALLBACK_MIN_UNIT_QUANTITY = 3;

/** Maximum card quantity for business subscription */
export const MAX_UNIT_QUANTITY = 20000;

/** Maximum quantity for the post-checkout seat selection slider. */
export const TRIAL_QUANTITY_MAX = 100;
